<template>
    <accordion
        header-class="cursor-pointer"
        :is-active="isExpanded"
        @header-click="toggleShopExpand"
    >
        <template #header>
            <h5 class="mb-0" v-text="`${shop.full_name}, ${shop.fullAddress}`" />
        </template>

        <template #expand-button>
            <div class="text-md text-nowrap">
                <strong v-text="$options.filters.currency(shopSummaryPrice)" />
                <a-icon class="pl-1" :icon="isExpanded ? 'ArrowUp' : 'ArrowDown'" />
            </div>
        </template>

        <template #body>
            <div class="summary-shop-table">
                <div class="summary-shop-table__row --header">
                    <div v-text="'Wybrany pakiet'" />
                    <div v-text="'Czy wybrany'" />
                </div>

                <div class="summary-shop-table__row">
                    <div v-text="shopTariff.name" />
                    <div v-text="'TAK'" />
                </div>
                <div class="summary-shop-table__row">
                    <div v-text="'Opcje dodatkowo płatne, w tym:'" />
                    <div v-text="shop.additionalDevices ? 'TAK' : 'NIE'" />
                </div>
                <div
                    v-for="(optional, oIndex) in shopTariff.optionals.list"
                    :key="oIndex"
                    v-text="optional.name"
                    class="summary-shop-table__row summary-shop-table__optional-name"
                />
            </div>
        </template>
    </accordion>
</template>

<script>
import cloneDumb from '@/helpers/cloneDumb'
import { mapGetters } from 'vuex'
import { CONFIG_MODES } from '@/store/modules/drs/tariffs.module'

export default {
    props: {
        shop: {
            type: Object,
            required: true
        },
        isExpanded: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapGetters('drsTariffs', ['selectedTariff', 'cart']),

        shopCart() {
            return (this.cart?.locations || []).find(loc => loc.bo_location_id === this.shop.id) || {}
        },

        isEditMode() {
            return this.configMode === CONFIG_MODES.EDIT
        },

        shopSummaryPrice() {
            if (!this.shopCart || !this.shopCart.payment_price_net) {
                return 0
            }

            if (this.isEditMode && !this.areChangesMade) {
                return 0
            }

            return this.shopCart.payment_price_net / 100
        },

        shopTariff() {
            const tariff = cloneDumb(this.selectedTariff)

            tariff.location = tariff.locations.find(loc =>
                loc.selected &&
                loc.id === this.shop.id
            ) || {}
            return tariff
        }
    },

    methods: {
        toggleShopExpand() {
            this.$emit('expand-shop', this.shop.id)
        }
    }
}
</script>

<style lang="scss">
.summary-shop-table {
    --small-col-width: 6rem;

    .textarea {
        resize: none
    }

    &__row {
        display: flex;
        justify-content: space-between;
        padding: 0.5rem 0;
        gap: 1rem;

        &.--header {
            font-weight: bold;
            color: var(--color-primary);
        }

        > :nth-child(1) {
            width: 100%;
        }
        > :nth-child(2) {
            width: var(--small-col-width);
            min-width: var(--small-col-width);
            text-align: right;
        }
    }

    &__optional-name {
        display: list-item;
        margin-left: 1rem;
    }

    &.--service {
        padding-top: 0.5rem;
        margin-top: 0.5rem;
        border-top: 1px solid var(--color-border);

        .summary-shop-table {
            &__row {
                > :nth-child(1) {
                    width: 80%;
                }
                > :nth-child(2) {
                    text-align: right;
                    width: 20%;
                }
            }
        }
    }
}
</style>